import { render } from "./ManageSalesChannelsModal.vue?vue&type=template&id=c89f5b96"
import script from "./ManageSalesChannelsModal.vue?vue&type=script&lang=js"
export * from "./ManageSalesChannelsModal.vue?vue&type=script&lang=js"

import "./ManageSalesChannelsModal.vue?vue&type=style&index=0&id=c89f5b96&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__